import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastContainer, Slide, cssTransition } from 'react-toastify';
import 'animate.css/animate.min.css';
import 'react-toastify/dist/ReactToastify.css';

// 언어 스토어 먼저 초기화
import { initializeLanguageStore } from '@/store/modules/languageStore';
// i18n 설정
import './config/i18n';

// default theme with MUI
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '@/layouts/themes/defaultTheme';

import { DialogContainer, dialogInit } from '@/modules/MuiDialog';

import '@/styles/index.scss';
import '@/styles/mui-override.scss';
import '@/styles/react-toastfy-override.scss';

import { LicenseInfo } from '@mui/x-license-pro';
import { infra, env } from './constant/configure';
import { CookiesProvider } from 'react-cookie';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/config/queryClient';

LicenseInfo.setLicenseKey(infra.license.mui_license || '');
Sentry.init({
    dsn: 'https://22f96388a29cfe856c41ffe84668fd2c@o4508776190377984.ingest.us.sentry.io/4508804647092224',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: env || 'DEV',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: env?.toUpperCase() === 'PRD',
    normalizeDepth: 6,
    attachStacktrace: true,
});
const bounce = cssTransition({
    enter: 'animate__animated animate__fadeIn',
    exit: 'animate__animated animate__zoomOut',
});

window.addEventListener('error', (e) => {
    Sentry.captureException(e);
});
window.addEventListener('unhandledrejection', (e) => {
    const error = e.reason;
    Sentry.captureException(error);
});
window.addEventListener('abort', (e) => {
    Sentry.captureException(e);
});
window.onerror = function (message, source, lineno, colno, error) {
    Sentry.captureException(error || new Error(typeof message === 'string' ? message : String(message)));
    return false;
};

// 언어 스토어 초기화 (i18n도 함께 초기화됨)
initializeLanguageStore();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <CookiesProvider>
                <CssVarsProvider theme={theme}>
                    <CssBaseline />
                    <App />
                    <ToastContainer
                        closeOnClick
                        draggable
                        transition={bounce}
                        theme={'colored'}
                        hideProgressBar={true}
                        autoClose={3000}
                        pauseOnFocusLoss={false}
                        position="bottom-center"
                    />
                </CssVarsProvider>
            </CookiesProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
